export default __webpack_public_path__ + "static/joonsung-0f06de0d7c46c9ca36cb715805e3eb38.jpeg";